import { Suspense, lazy } from 'react';
import LoadingScreen from 'src/componentes/LoadingScreen';

const Permissoes = lazy(() => import('../EditPage/permissao'));

function PermissoesTab({ model, isDisabled }) {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Permissoes
        parameters={{ documentoId: model?.id }}
        disabled={isDisabled}
      />
    </Suspense>
  );
}

export default PermissoesTab;
